import { PATH_NAME_LIST } from '@/common/router.const'

/**
 * 구형 view more 클릭 시 view more 페이지로 이동하는 객체 반환
 * @param url
 * @returns { any }
 */
export const navigateViewMoreOldFashioned = (url) => {
  console.log('old-fashioned view more url:', url)
  const regExp = /uicode=(\w+)/gi
  const [urlUiCode] = url.match(regExp) || []

  if (!urlUiCode) {
    return undefined
  }

  const [_, uiCode] = urlUiCode?.split('=')

  return {
    name: PATH_NAME_LIST,
    params: {
      url,
      uiCode,
    },
    query: {
      api: encodeURIComponent(url),
    },
  }
}
